import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { toHTML, Editor, Toolbar } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RequestAssistanceModal } from '../../models/requestAssistanceModel';
import { ContractService } from '../../services/contract.service';

@Component({
  selector: 'app-request-assistance',
  templateUrl: './request-assistance.component.html',
  styleUrls: ['./request-assistance.component.css']
})
export class RequestAssistanceComponent implements OnInit, OnDestroy {
  public model: RequestAssistanceModal
  toolbar: Toolbar;
  editor: Editor;
  sendingEmail: boolean;
  editordoc: any;
  constructor(private dialogRef: MatDialogRef<RequestAssistanceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RequestAssistanceModal,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,
    public contractService: ContractService) {
    this.model = data ? data : new RequestAssistanceModal();
  }
  get disabled(): boolean {    
    return (!this.editordoc || (this.editordoc && toHTML(this.editordoc).trim().replace(/\s/g, '') === '<p></p>'));
  }
  send() {
    this.model.message = toHTML(this.editordoc);
    this.sendingEmail = true;
    this.loader.start();
    this.contractService.sendAssistanceRequest(this.model).subscribe(success => {
      this.loader.stop();
      this.sendingEmail = false;
      if (success) {
        this.toastr.success("Your request for assistance has been sent to the consultant");
        this.dialogRef.close();
      } else {
        this.toastr.error("Something went wrong while sending your request, please try again");
      }
    }, error => {
      this.loader.stop();
      this.sendingEmail = false;
      this.toastr.error("Something went wrong while sending your request, please try again");
    });
  }

  ngOnInit(): void {
    this.editor = new Editor();
    this.toolbar = [
      ['bold', 'italic', 'underline', 'strike'],
      ['code', 'blockquote'],
      ['ordered_list', 'bullet_list'],
      [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
      ['link', 'image'],
      ['text_color', 'background_color'],
      ['align_left', 'align_center', 'align_right', 'align_justify'],
    ];
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
